import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { registryParticipantDataFunc } from "../../../../../data-store/actions/registry-actions";
import CodePayment from "./CodePayment";
import EmailConfirm from "./EmailConfirm";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "black",
  },
  paper: {
    padding: "20px",
    backgroundColor: "#283747",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
  },
  buttons: {
    margin: 30,
    width: "250px",
    color: "black",
  },
}));

export default function SaveAthleteDataView(props) {
  const {
    callback,
    callbackCode,
    order,
    test,
    currency,
    currentOrder,
    eventDetail,
    enGrupo,
    onAddOther,
    onFinishGroup,
  } = props;
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const athleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const classes = useStyles();
  const { t } = useTranslation("inscripcion");
  const [emailConfirm, setEmailConfirm] = useState(false);
  const [guardandoOtro, setGuardandoOtro] = useState(false);
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );

  function callbackConfirm(data) {
    console.log("data", data);
    setEmailConfirm(data);
  }

  function saveAthleteDataAndPay() {
    console.log(currentOrder);
    if (enGrupo) {
      // ya hay otros atletas en el grupo: este también se guarda pendiente
      // y se pasa al resumen del grupo, no se paga directo.
      onFinishGroup();
      return;
    }
    dispatch(
      registryParticipantDataFunc(
        "evento_" + eventDetail.iDEvento,
        currentOrder,
        1,
        userID
      )
    );
    callback();
  }

  async function saveAthleteDataAndAddOther() {
    setGuardandoOtro(true);
    try {
      await onAddOther();
    } finally {
      setGuardandoOtro(false);
    }
  }

  return (
    <Grid
      container
      direction="row"
      style={{
        height: "auto",
        width: "100%",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        style={{ padding: "10px", textAlign: "center" }}
      >
        <Typography color="primary" component="h1" variant="h6">
          {t("pago.totalAPagar")}
        </Typography>
        <Typography color="primary" component="h1" variant="h3">
          {order &&
            order.reduce(function (acc, obj) {
              return (
                acc +
                Math.round(
                  parseFloat(obj.unit_price) *
                    obj.quantity *
                    currency.tipoCambio *
                    100
                ) /
                  100
              );
            }, 0)}{" "}
          {currency.codigo}
        </Typography>
      </Grid>
      {!emailConfirm && (
        <EmailConfirm
          callbackConfirm={callbackConfirm}
          currentOrder={currentOrder}
        />
      )}

      {registryConfiguration.configuracion.formasDePago.codigoDescuento &&
        emailConfirm && (
          <Grid
            item
            xs={12}
            sm={12}
            style={{ padding: "0px", textAlign: "center" }}
          >
            <CodePayment
              callbackCode={callbackCode}
              currency={currency}
              currentOrder={currentOrder}
              eventDetail={eventDetail}
            />
          </Grid>
        )}
      {emailConfirm && (
        <Grid
          item
          xs={12}
          sm={12}
          style={{ padding: "20px", textAlign: "center" }}
        >
          <Button
            onClick={() => saveAthleteDataAndPay()}
            variant="contained"
            color="primary"
            disabled={guardandoOtro}
            style={{
              height: "150px",
              width: "100%",
              fontSize: "18px",
            }}
          >
            {enGrupo
              ? t("guardarYAgregar.continuarResumenGrupo")
              : order &&
                order.reduce(function (acc, obj) {
                  return (
                    acc +
                    Math.round(
                      parseFloat(obj.unit_price) *
                        obj.quantity *
                        currency.tipoCambio *
                        100
                    ) /
                      100
                  );
                }, 0) > 0
              ? t("guardarYAgregar.continuarConPago")
              : t("guardarYAgregar.continuarFinalizar")}
          </Button>
          <Button
            onClick={() => saveAthleteDataAndAddOther()}
            variant="outlined"
            color="primary"
            disabled={guardandoOtro}
            style={{
              height: "60px",
              width: "100%",
              fontSize: "16px",
              marginTop: "10px",
            }}
          >
            {guardandoOtro
              ? t("guardarYAgregar.guardando")
              : t("guardarYAgregar.agregarOtroParticipante")}
          </Button>
        </Grid>
      )}
    </Grid>
  );
}
